import React, { useRef } from "react";
import { Button, Icon, Modal } from "semantic-ui-react";
import useQrCode from "../hooks/useQrCode";
import { QRCodeSVG } from "qrcode.react";
import ToggleButtonGroup from "../shared/forms/ToggleButtonGroup";

const QrCodeModal = () => {
  const {
    open,
    qrValue,
    locations,
    toggleVisibility,
    toggleLocation,
    downloadQrCode,
  } = useQrCode();
  const qrCodeRef = useRef(null);

  return (
    <Modal closeIcon open={open} size="mini" onClose={toggleVisibility}>
      <Modal.Header>QR Code</Modal.Header>
      <Modal.Content className="text-center">
        <ToggleButtonGroup
          value={qrValue.location}
          options={locations}
          onToggle={toggleLocation}
          label="Select location: "
          fieldStyle="mb-3"
          labelStyle="m-auto mb-2"
        />
        {qrValue.location && (
          <QRCodeSVG
            ref={qrCodeRef}
            size={128}
            value={JSON.stringify(qrValue)}
          />
        )}
      </Modal.Content>
      <Modal.Actions>
        <div className="text-center">
          <Button color="green" onClick={() => downloadQrCode(qrCodeRef)}>
            <Icon name="download" /> Download
          </Button>
        </div>
      </Modal.Actions>
    </Modal>
  );
};

export default QrCodeModal;
